module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/widget-detail/widget-detail-sunstudies/widget-detail-sunstudies.component.scss
// module id = ./src/app/widgets/widget-detail/widget-detail-sunstudies/widget-detail-sunstudies.component.scss
// module chunks = main